import Vue from 'vue'
import Router from 'vue-router'
import app from './default/'
import designRelatorio from './designRelatorio'
import out from './out'
import { checkRequireAuth } from './meta/requireAuth'
import { checkAcesso } from './meta/validaAcesso'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    app, designRelatorio, out,
    { path: '**', redirect: 'default' }
  ]
})

router.beforeEach((to, from, next) => {
  checkRequireAuth(to, from, next)
})
router.beforeResolve((to, from, next) => {
  checkAcesso(to, from, next)
})

export default router
